import React from 'react';
import '../styles/About.css';

function About() {
  return (
    <div className="about-section">
      <div className="about-content">
        <h2>About Us</h2>
        <p>Jeff Aron founded this business eight years ago, inspired by his passion for custom woodworking that first emerged when he designed and built his own home in Gainesville, Florida. With a keen eye for detail and a deep respect for traditional craftsmanship, Jeff approaches every project—whether it’s a standalone piece or an entire renovation—with the same commitment to quality and personal dedication.
</p>
<br/>
<p>Over the years, Jeff has remained steadfast in his mission to deliver beautifully tailored woodworking solutions that reflect each client’s unique vision. He prioritizes clear communication, sustainable materials, and an unwavering focus on the finer details that transform ordinary builds into functional art. Jeff’s belief in building relationships as enduring as his creations is evident in every handshake, blueprint review, and final walk-through.

From custom cabinetry and hand-hewn furniture to complete home remodels, Jeff strives to combine modern techniques with time-honored craftsmanship.</p>
<br/>
<p>It’s not just about building something; it’s about building something meaningful—an experience where clients feel heard, involved, and thoroughly delighted with the final result.

Blending traditional woodworking artistry with fresh, forward-thinking design, Jeff Aron continues to set the standard for personalized service and unparalleled attention to detail—ensuring that each piece, project, and partnership stands the test of time.</p>
      </div>

      {/* <div className="about-images">
        <img 
          src="https://via.placeholder.com/400x300?text=Placeholder+1" 
          alt="Placeholder 1" 
        />
        <img 
          src="https://via.placeholder.com/400x300?text=Placeholder+2" 
          alt="Placeholder 2" 
        />
      </div> */}
    </div>
  );
}

export default About;
